const initialState = {
  message: null,
  status: 'received',
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_ACCEPTED': {
      return {
        ...state,
        message: payload.message,
        status: payload.status,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/OAuth/Accepted/Accepted.reducer.js